import { KbArticlePage } from '../../content/types/content/kb-article';

export const isPlatformApplicable = (page: KbArticlePage): boolean => {
    if (!page || !page.productVersions) {
        return false;
    }
    let platformApplicable = false;
    for (const productVersion of page.productVersions) {
        if (productVersion.product.productName !== 'Jira Align') {
            platformApplicable = true;
            break;
        }
    }
    return platformApplicable;
};
